<template>
  <div>
    <nav class="nav nav-pills mb-3">
      <router-link
        v-if="$auth.check('admins_page_tab')"
        :to="{name:'Admins'}"
        class="mr-3 nav-link"
        exact-active-class="active"
      >
        Admins
      </router-link>
      <router-link
        v-if="$auth.check('roles_page_tab')"
        :to="{name:'Roles'}"
        class="mr-3 nav-link"
        exact-active-class="active"
      >
        Roles
      </router-link>
      <router-link
        v-if="$auth.check('permissions_page_tab')"
        :to="{name:'Permissions'}"
        class="nav-link"
        exact-active-class="active"
      >
        Permissions
      </router-link>
    </nav>
    <router-view />
  </div>
</template>

<script>
export default {
  name: "Admins",
  created() {
    if (this.$route.name === 'Admins' && !this.$auth.check('admins_page_tab')) {
      this.$router.push({name: 'Roles'});
      return;
    }
    if (this.$route.name === 'Roles' && !this.$auth.check('roles_page_tab')) {
      this.$router.push({name: 'Permissions'});
      return;
    }
    if (this.$route.name === 'Permissions' && !this.$auth.check('permissions_page_tab')) {
      this.$router.push({name: 'Admins'});
      return;
    }
  }
}
</script>

<style scoped>

</style>
